export default function NumpyUfunc_FindingLCM() {
  return <div>NumpyUfunc_FindingLCM Component</div>;
}
